import { logger } from '@adornis/base/logging.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam } from '../exam.js';
import { Teacher } from '../teacher.js';

/**
 * Adds `className` to the class list of the teacher who owns `examId`, if not already present.
 * A teacher's classes are never edited directly — they accumulate from every exam (Klassenarbeit
 * or Test alike) that gets a class assigned, so writing the same class from two exams is a no-op.
 */
export async function syncTeacherClassFromExam(examId: string, className: string | null | undefined): Promise<void> {
  const trimmedClass = typeof className === 'string' ? className.trim() : '';
  if (!trimmedClass) return;

  try {
    const examCollection = await getCollection(Exam);
    const exam = await examCollection.findOne({ _id: examId }, { projection: { userID: 1 } });
    const userID = (exam as any)?.userID;
    if (!userID) return;

    const teacherCollection = await getCollection(Teacher);
    // `classes` may still be `null` on teachers created before the field got a default (see
    // Teacher.classes) — $addToSet rejects a non-array field, so coerce it to an array first.
    await teacherCollection.updateOne({ userID }, [
      {
        $set: {
          classes: { $setUnion: [{ $cond: [{ $isArray: '$classes' }, '$classes', []] }, [trimmedClass]] },
        },
      },
    ]);
  } catch (err) {
    logger.error({ err, examId, className: trimmedClass }, 'Failed to sync class onto teacher');
  }
}
